import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import {
  getCarrierBeneficiaries,
  getFormData,
  getFormUploads,
  getProcessInstances,
  updateFormField,
} from 'store/forms/actions';
import { TabsTimeline, FormFooter } from 'components';
import { isNil } from 'lodash';
import {
  checkUser,
  checkUserLogged,
  getUser,
  getTaxisData,
  updateUserNp,
} from 'store/user/actions';
import { getMainformDetails } from 'store/forms/actions';
import { Steps } from './steps';
import { useNavigate } from 'react-router-dom';
import { isAdminUser, isBeneficiary } from '../../../utils';

import isEmpty from 'lodash/isEmpty';
import { Spin } from 'antd';

const MainForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [current, setCurrent] = useState(0);
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const activeFormId = useSelector(state => state?.activeForm?.activeFormId);
  const investmentExpenses = useSelector(
    state => state.forms.documents?.investmentExpenses
  );
  const loadingPage = useSelector(state => state.user?.loading ?? true);
  const banner = useSelector(state => state.appTrack?.banner);
  const [viewModeLoading, setViewModeLoading] = useState(true);
  const [loadingPageVar, setLoadingPageVar] = useState(true);
  const canViewPage = !isAdminUser(user?.groups);
  const [entered, setEntered] = useState(false);
  const carrier = useSelector(state => state.forms.carrier);
  const parseFlag = useSelector(state => state.forms.carrier.parseFlag);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const processInstanceId = useSelector(
    state => state.forms.task.processInstanceId
  );
  const companyLegalType = useSelector(
    state => state.forms.carrier.companyLegalType
  );

  console.log('companyLegalType:', companyLegalType);
  // console.log("investmentExpenses",investmentExpenses);
  useEffect(() => {
    dispatch(getUser());
    dispatch(getTaxisData());
    //dispatch(getCarrierBeneficiaries());

    dispatch(getFormData(params.taskId));
    dispatch(getFormUploads(params.taskId));
    if (window.location.pathname.includes('view')) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'viewMode',
          value: true,
        })
      );
    }
  }, [dispatch, params.taskId]);

  // Skip API call for 'Ατομική' since beneficiaries are handled locally in SubTab3
  useEffect(() => {
    if (companyLegalType && companyLegalType !== 'Ατομική') {
      dispatch(getCarrierBeneficiaries(companyLegalType));
    }
  }, [companyLegalType, dispatch]);

  useEffect(() => {
    if (investmentExpenses && !entered) {
      dispatch(getFormData(params.taskId));
      setEntered(true);
    } else if (!investmentExpenses) {
      setEntered(false);
    }
  }, [investmentExpenses]);

  useEffect(() => {
    if (!isEmpty(task)) {
      setTimeout(() => setViewModeLoading(false), 3000);
    }
  }, [task]);

  // useEffect(() => {
  //  if (!canViewPage) navigate('/appTrack', { replace: true });
  //  const procId = isNil(processInstanceId) ? activeFormId : processInstanceId
  //  if(viewMode || (activeTaskName && activeTaskName !== 'task.name.submit_application')){
  //     console.log("call getMainformDetails", activeFormId, params.taskId)
  //   dispatch(getMainformDetails(procId));
  //  }
  // }, [activeTaskName, activeFormId, processInstanceId, canViewPage, viewMode]);

  useEffect(() => {
    if (!canViewPage) {
      navigate('/appTrack', { replace: true });
    }
  }, [canViewPage, navigate]);

  useEffect(() => {
    if (
      viewMode ||
      (activeTaskName && activeTaskName !== 'task.name.submit_application')
    ) {
      if (!isEmpty(task?.processInstanceId)) {
        dispatch(
          getMainformDetails(
            task?.processInstanceId || activeFormId,
            user?.groups,
            params?.taskId
          )
        );
      }
    }
  }, [processInstanceId, activeTaskName, viewMode]);

  useEffect(() => {
    setLoadingPageVar(loadingPage || viewModeLoading);
  }, [loadingPage, viewModeLoading]);

  useEffect(() => {
    console.log('Firm Flag Deployed');
    if (user?.taxis_data?.firmFlag === '1') {
      dispatch(updateUserNp(true));
    } else {
      dispatch(updateUserNp(false));
    }
  }, [user.taxis_data, dispatch]);

  useEffect(() => {
    dispatch(
      checkUserLogged(navigate, callback => {
        if (callback) {
          dispatch(getUser());
        }
      })
    );
  }, [dispatch, navigate]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(checkUser(navigate));
    }, process.env.REACT_APP_SESSION_CHECK_TIME);
    return () => clearInterval(intervalId);
  }, [navigate, dispatch]);

  useEffect(() => {
    if (task && task.processInstanceId && viewMode === true) {
      console.log('call getProcessInstances');
      dispatch(
        getProcessInstances({
          processInstanceId: task.processInstanceId,
          taskId: params.taskId,
        })
      );
    }
  }, [task.processInstanceId, params.taskId, viewMode]);

  const renderBeneficiary = parseFlag => {
    return Steps(parseFlag);
  };

  return loadingPageVar ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <div id="mainforms-page-1" className="investor-form-container">
      {!isNil(current) && (
        <div className="investor-steps-footer-container">
          {!viewMode &&
            banner?.render &&
            banner?.message &&
            isBeneficiary(user?.groups) && (
              <div className="stepper-warning-message">
                <div>{banner?.message}</div>
              </div>
            )}
          {!viewMode &&
            isBeneficiary(user?.groups) &&
            (carrier.businessSize == 'Μεσαία' ||
              carrier.businessSize == 'Μεγάλη') && (
              <div className="stepper-warning-message error-message">
                <div>
                  Δεν πληροίτε τις προϋποθέσεις υποβολής αίτησης στο πρόγραμμα,
                  καθώς σύμφωνα με τη δήλωση ΜΜΕ, η επιχείρησή σας δεν
                  κατατάσσεται στην κατηγορία των Πολύ Μικρών ή Μικρών
                  Επιχειρήσεων.{' '}
                </div>
              </div>
            )}
          {isBeneficiary(user?.groups) &&
            task.taskName == 'task.name.application_evaluated' && (
              <div className="stepper-warning-message">
                <div>
                  Σε περίπτωση που επιθυμείτε να προσθέσετε νέες δαπάνες στο
                  επενδυτικό σας πλάνο, σας ενημερώνουμε ότι δεν είναι δυνατή η
                  τροποποίηση αίτησης που έχει ήδη υποβληθεί. Για τον λόγο αυτό,
                  παρακαλούμε να προχωρήσετε πρώτα στην ακύρωση της τρέχουσας
                  αίτησής σας και στη συνέχεια να υποβάλετε νέα αίτηση με το
                  σύνολο των δαπανών που επιθυμείτε να συμπεριλάβετε.
                </div>
              </div>
            )}
          <TabsTimeline
            tabs={renderBeneficiary()}
            current={current}
            setCurrent={setCurrent}
            customClass={`custom-tabs-timeline active-tab-${current + 1}`}
          />
          <FormFooter
            tabs={renderBeneficiary()}
            current={current}
            setCurrent={setCurrent}
            currentSubTab={currentSubTab}
          />
        </div>
      )}
    </div>
  );
};

export default MainForm;
